export default "__VITE_PUBLIC_ASSET__6fd6ba9b__"